import {css} from 'lit';
export const styles = css`.heading {
    display: flex;
    flex-direction: row;

    align-items: center;
}

    .heading h1 {
        flex-grow: 1;
    }
`;
export default styles;
